module.exports = __webpack_public_path__ + "static/media/news_active.29795af3.svg";